import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    gradient: {
      position: 'absolute',
      zIndex: 1,
      width: '100%',
      height: 66,
      bottom: 0,
      left: 0,
      borderRadius: '0px 0px 5px 5px',
      background: `linear-gradient(0deg, ${colorsPalette.blueDark} 1.15%, rgba(31, 30, 41, 0.780328) 33.27%, rgba(45, 50, 56, 0.0001) 98.75%)`,
    },
  }),
);
export default useStyles;
